import { Button, Typography } from '@iheartjane/reefer';
import type { Spacing } from '@iheartjane/reefer';
import type { MouseEvent } from 'react';

import { UnlockWalletWrapper } from '@jane/monolith/components/cart/pendingCartDrawer/cartDrawerSpecials/customerLoyaltyPoints/customerLoyaltyPoints.styles';
/* eslint-disable-next-line no-restricted-imports */
import type { CrmDetails } from '@jane/shared/models';
import { formatPhone } from '@jane/shared/util';

export const InitiateUnlockWallet = ({
  crmDetails,
  headless,
  onSendCode,
  loading,
}: {
  crmDetails: CrmDetails;
  headless?: boolean;
  loading: boolean;
  onSendCode: (e: MouseEvent) => void;
}) => (
  <UnlockWalletWrapper headless={headless}>
    <Typography variant="body">
      Please confirm your identity by entering a verification code sent to the
      following
      {crmDetails.integration_type === 'email' ? (
        <>
          {' '}
          email address:{' '}
          <Typography variant="body-bold"> {crmDetails.crmId}. </Typography>
        </>
      ) : (
        <>
          {' '}
          phone number:{' '}
          <Typography variant="body-bold">
            {' '}
            {formatPhone(crmDetails.crmId)}.
          </Typography>
        </>
      )}
    </Typography>
    <Button
      full
      variant="secondary"
      onClick={onSendCode}
      loading={loading}
      label="Send code"
      mt={10 as Spacing}
    />
  </UnlockWalletWrapper>
);
